// extracted by mini-css-extract-plugin
module.exports = {"transactionHistory":"Transaction_transactionHistory__2KwI-","thead":"Transaction_thead__3iVp7","table":"Transaction_table__3AJjV"};